/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PriceOfferResponse } from '../model';
/**
 * PriceOfferControllerApi - axios parameter creator
 * @export
 */
export const PriceOfferControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} zone 
         * @param {string} planOptionId 
         * @param {string} [discountCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceOfferForMember: async (zone: number, planOptionId: string, discountCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zone' is not null or undefined
            assertParamExists('getPriceOfferForMember', 'zone', zone)
            // verify required parameter 'planOptionId' is not null or undefined
            assertParamExists('getPriceOfferForMember', 'planOptionId', planOptionId)
            const localVarPath = `/price-offer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (zone !== undefined) {
                localVarQueryParameter['zone'] = zone;
            }

            if (planOptionId !== undefined) {
                localVarQueryParameter['planOptionId'] = planOptionId;
            }

            if (discountCode !== undefined) {
                localVarQueryParameter['discountCode'] = discountCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PriceOfferControllerApi - functional programming interface
 * @export
 */
export const PriceOfferControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PriceOfferControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} zone 
         * @param {string} planOptionId 
         * @param {string} [discountCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPriceOfferForMember(zone: number, planOptionId: string, discountCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceOfferResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPriceOfferForMember(zone, planOptionId, discountCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PriceOfferControllerApi - factory interface
 * @export
 */
export const PriceOfferControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PriceOfferControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} zone 
         * @param {string} planOptionId 
         * @param {string} [discountCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceOfferForMember(zone: number, planOptionId: string, discountCode?: string, options?: any): AxiosPromise<PriceOfferResponse> {
            return localVarFp.getPriceOfferForMember(zone, planOptionId, discountCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PriceOfferControllerApi - object-oriented interface
 * @export
 * @class PriceOfferControllerApi
 * @extends {BaseAPI}
 */
export class PriceOfferControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} zone 
     * @param {string} planOptionId 
     * @param {string} [discountCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriceOfferControllerApi
     */
    public getPriceOfferForMember(zone: number, planOptionId: string, discountCode?: string, options?: AxiosRequestConfig) {
        return PriceOfferControllerApiFp(this.configuration).getPriceOfferForMember(zone, planOptionId, discountCode, options).then((request) => request(this.axios, this.basePath));
    }
}

